<div class="spinner-css-container">
    <div class="spinner-css"></div>
</div>

<style>
    .spinner-css-container {
        height: 100%;
        min-height: 20px;
        width: 100%;
        position: relative;
        transform: translate(-10px, -10px);
    }
    .spinner-css:after {
        content: ' ';
        position: absolute;
        display: block;
        left: 50%;
        top: 50%;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        border: 3px solid #444444;
        border-color: #444444 transparent #444444 transparent;
        animation: spinner-css-animation 1.2s linear infinite;
        z-index: 100002;
        transform: translate(-50%, -50%);
    }

    @keyframes spinner-css-animation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>
